import React, { useState } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import axios from "axios";

const AccessModals = ({
  grantAccess,
  closeOneTimeAccess,
  handleAccessSubmit,
  number,
  setNumber,
  setGrantAccess,
  AccessSuccess,
  AccessSuccessIsClosed,
  clockInDetails,
  AccessFailure,
  AccessFailureIsClosed,
  clockInError,
  onAccessSuccess,
}) => {

  return (
    <>
      <Modal
        isOpen={grantAccess}
        onRequestClose={closeOneTimeAccess}
        contentLabel="Grant One time Access"
        className="view-staff-modal"
      >
        <div>
          <div className="enter-password">
            <h2>Provide Access</h2>
          </div>
          <p>
            Enter member’s registered phone number to provide one-time access to
            the gym.
          </p>
          <form className="view-staff-form" onSubmit={handleAccessSubmit}>
            <label htmlFor="password">Member's Phone Number:</label>
            <br />
            <input
              type="number"
              id="number"
              name="number"
              value={number}
              required
              onChange={(e) => setNumber(e.target.value)}
              style={{ fontSize: "14px" }}
            />
            <div className="modal-button">
              <button
                type="button"
                onClick={() => {
                  closeOneTimeAccess();
                  setNumber("");
                }}
              >
                Cancel
              </button>
              <button type="submit">Submit</button>
            </div>
          </form>
        </div>
      </Modal>

      <Modal
        isOpen={AccessSuccess}
        onRequestClose={AccessSuccessIsClosed}
        contentLabel="Success Modal"
        className="edit-success-modal"
      >
        <img src={`${process.env.PUBLIC_URL}/images/thumbs-up.png`} alt="Success" />
        <h2 style={{ fontWeight: "bolder" }}>Clock-in Success</h2>
        <div className="qr-notif-box" style={{ marginTop: "10px" }}>
          <img
            src={
              clockInDetails.profile_image
                ? clockInDetails.profile_image
                : `${process.env.PUBLIC_URL}/images/settings-avatar.png`
            }
            alt="Profile"
          />
          <div className="qr-notif-details">
            <p>
              <span className="notif-span">Name:</span> {clockInDetails.f_name}{" "}
              {clockInDetails.l_name}
            </p>
            <p>
              <span className="notif-span">Gym Number:</span>#
              {clockInDetails.id}
            </p>
          </div>
        </div>
        <button onClick={AccessSuccessIsClosed}>Close</button>
      </Modal>

      <Modal
        isOpen={AccessFailure}
        onRequestClose={AccessFailureIsClosed}
        contentLabel="Error Modal"
        className="edit-success-modal clock-in-failure"
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/delete-danger.png`}
          alt="Error"
        />
        <h2 style={{ fontWeight: "bolder" }}>{clockInError}</h2>

        {clockInError === "user not found" && (
          <p style={{ fontSize: "16px", color: "#737373", marginTop: "15px" }}>
            User is not registered yet. Kindly, register user to gain access to
            the gym.
          </p>
        )}

        {clockInError === "user not found" ? (
          <div className="clock-in-btns">
            <button onClick={AccessFailureIsClosed}>Cancel</button>
            <Link to="/member-management">
              <button
                onClick={AccessFailureIsClosed}
                style={{ color: "white", backgroundColor: "#0473bd" }}
              >
                Register User
              </button>
            </Link>
          </div>
        ) : (
          <button
            onClick={AccessFailureIsClosed}
            style={{ width: "350px", marginBottom: "24px" }}
          >
            Cancel
          </button>
        )}
      </Modal>
    </>
  );
};

export default AccessModals;
